export const CREATE_MEDIA_OPTIONS = [
  {
    cardName: "Mailer Campaigns",
    name: "Mailer Campaign",
    url: "/launch?slug=brivity-marketer&redirectPath=/create-mailer",
  },
  {
    cardName: "Digital Ads",
    name: "Social Media Ad",
    url: "/launch?slug=brivity-marketer&redirectPath=/ads/create-ad",
  },
  {
    cardName: "Printed Media",
    name: "Print Media",
    url: "/launch?slug=brivity-marketer&redirectPath=/create-print-media",
  },
  {
    cardName: "Social Media Graphics",
    name: "Social Media Post",
    url: "/launch?slug=brivity-marketer&redirectPath=/create-social-media",
  },
  { cardName: "Videos", name: "Video", url: "/launch?slug=brivity-marketer&redirectPath=/create-video" },
];

export const getCardLink = (name) => CREATE_MEDIA_OPTIONS.filter((option) => option.cardName === name)[0];

export const getImglink = (avatarCollection) => {
  const defaultAvatarUrl = "/assets/user-default.svg";
  const isCustomAvatar = (url) => url !== defaultAvatarUrl;
  const size = "public"; // or the size we want to use
  if (isCustomAvatar(avatarCollection[size])) {
    return avatarCollection[size];
  }
  return null;
};
